import styled from "styled-components";
import {
  headerHeightMedium,
  minMedium,
} from "@songtradr-one/components-frontend";

// TEXT

// STYLES
export const Container = styled.div`
  @media ${minMedium} {
    display: flex;
    flex-direction: column;
    /* Fallback pair: browsers that don't support "safe" treat the value as
       invalid and drop the whole declaration, keeping this plain center;
       browsers that do support it override with the overflow-safe one. */
    justify-content: center;
    justify-content: safe center;
    padding-bottom: 3.75rem;
    height: calc(100vh - ${headerHeightMedium});
  }
`;

export const Backdrop = styled.div<{ $image: string }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  background: ${({
    $image,
  }) => `linear-gradient(0.64deg, #121212 0.61%, rgba(18, 18, 18, 0) 53.04%),
    linear-gradient(90deg, rgba(18, 18, 18, 0) 46.77%, #121212 100%),
    linear-gradient(90deg, #121212 0%, rgba(18, 18, 18, 0) 54.41%),
      url(${$image}) no-repeat center top / cover`};
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
